import styles from "./EditUser.module.css";
import axios from "axios";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ChangePasswordModal from "./ChangePasswordModal";

function UserProfile() {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [cellphone, setCellphone] = useState("");
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [message, setMessage] = useState("");
  const token = useSelector((state) => state.user.info.token);

  const updatedSuccesfully = () => toast.info("Your account has been updated!");
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_API_URL}/users`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response) {
          setFirstname(response.data.firstname);
          setLastname(response.data.lastname);
          setCellphone(response.data.cellphone);
          setAddress(response.data.address);
          setCountry(response.data.country);
          setCity(response.data.city);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getUser();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/users`,
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}` },
        data: {
          firstname,
          lastname,
          address,
          cellphone,
          country,
          city,
        },
      });
      if (response) {
        updatedSuccesfully();
      }
    } catch (error) {
      setMessage(error.response.data.msg);
    }
  };

  return token ? (
    <div className="container">
      <div className="row ">
        <main className="col-12 ">
          <div
            className={styles.title + " d-flex align-items-center pt-3 mb-3"}
          >
            <h1 className={styles.info + " h2 mb-0"}>Personal information</h1>
            <button className={styles.submit + " btn"} onClick={handleShow}>
              Change your password
            </button>
          </div>

          <div
            className={styles.form_container + " d-flex justify-content-center"}
          >
            <form
              id="updateUserInfo"
              className="d-flex flex-column align-items-center"
              onSubmit={handleSubmit}
            >
              <div className="mb-3">
                <label
                  htmlFor="firstname"
                  className={styles.label + " form-label mb-1"}
                >
                  Firstname *
                </label>
                <input
                  value={firstname}
                  type="text"
                  className={styles.input + " form-control"}
                  id="firstname"
                  name="firstname"
                  onChange={(event) => setFirstname(event.target.value)}
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="lastname"
                  className={styles.label + " form-label mb-1"}
                >
                  Lastname *
                </label>
                <input
                  value={lastname}
                  type="text"
                  className={styles.input + " form-control"}
                  id="lastname"
                  name="lastname"
                  onChange={(event) => setLastname(event.target.value)}
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="cellphone"
                  className={styles.label + " form-label mb-1"}
                >
                  Cellphone *
                </label>
                <input
                  value={cellphone}
                  type="string"
                  className={styles.input + " form-control"}
                  id="cellphone"
                  name="cellphone"
                  onChange={(event) => setCellphone(event.target.value)}
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="address"
                  className={styles.label + " form-label mb-1"}
                >
                  Address
                </label>
                <input
                  value={address}
                  className={styles.input + " form-control"}
                  type="text"
                  id="address"
                  name="address"
                  onChange={(event) => setAddress(event.target.value)}
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="city"
                  className={styles.label + " form-label mb-1"}
                >
                  City
                </label>
                <input
                  value={city}
                  className={styles.input + " form-control"}
                  type="text"
                  id="city"
                  name="city"
                  onChange={(event) => setCity(event.target.value)}
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="country"
                  className={styles.label + " form-label mb-1"}
                >
                  Country
                </label>
                <input
                  value={country}
                  className={styles.input + " form-control"}
                  type="text"
                  id="country"
                  name="country"
                  onChange={(event) => setCountry(event.target.value)}
                />
              </div>
              <p className="text-danger py-2">{message}</p>
              <div className="mb-3 d-flex justify-content-end">
                <button
                  type="submit"
                  className={styles.submit + " btn btn-primary"}
                >
                  Update your account
                </button>
              </div>
            </form>
            <ChangePasswordModal show={show} token={token} setShow={setShow} />
          </div>
        </main>
      </div>
    </div>
  ) : (
    <p>Loading...</p>
  );
}
export default UserProfile;
